<template>
  <div class="yoqb-layer noscroll">
    <div class="yoqb-layer yoqb-close" @click="$emit('yoask', false)"></div>

    <div class="yoqb-layer yoqb-question" v-if="yoask.mode === 'confirmGoAhead'">
      <div class="absorb">
        <div class="ui-title center-h">
          {{ yoask.displayMsg }}
        </div>

        <!-- OMG -->
        <div class="center-h" v-if="!yoask.closeOnly">
          <button class="maibutton yes" @click="() => { yoask.yes(); $emit('yoask', false) }">Yes</button>
          <button class="maibutton no" @click="() => { yoask.no(); }">No</button>
        </div>
        <div class="center-h" v-if="yoask.closeOnly">
          <button class="maibutton yes" @click="() => { $emit('yoask', false) }">Okay..</button>
        </div>
      </div>
    </div>

    <div class="yoqb-layer yoqb-question" v-if="yoask.mode === 'enter-password'">
      <div class="absorb">
        <div class="ui-title center-h">
          Please Enter Game Password
        </div>

        <div class="ui-title center-h">
          <input type="password" style="max-width: 80%;" class="enter-password" v-model="password">
        </div>

        <!-- OMG -->
        <div class="center-h">
          <button class="maibutton yes" @click="() => { yoask.yes(password); $emit('yoask', false); }">Yes, Enter the Room</button>
          <button class="maibutton no" @click="() => { yoask.no(); }">No</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    yoask: {}
  },
  data () {
    return {
      password: ''
    }
  }
}
</script>

<style>

</style>
